var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.55,8.68H17.27V7.27a5.27,5.27,0,1,0-10.53,0V8.68H5.55a1.85,1.85,0,0,0-1.84,1.84v9.64A1.85,1.85,0,0,0,5.55,22h13a1.85,1.85,0,0,0,1.84-1.84V10.52A1.85,1.85,0,0,0,18.55,8.68ZM8.82,7.27a3.19,3.19,0,1,1,6.37,0V8.68H8.82ZM18.3,19.91H5.8V10.77H18.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.05,16.71a1.37,1.37,0,1,0-1.37-1.37A1.37,1.37,0,0,0,12.05,16.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.9f8778f355d09280d45352c2409c1184.svg";
export { ForwardRef as ReactComponent };